window.gamePanelData = function () {
    return {
        usersWithMatches: [],
        pendingProposals: [],
        myPendingProposals: [],
        usersByStatus: { ready_to_play: [], online: [], in_game: [] },
        liveMatches: [],
        myOngoingMatches: [],
        loadingMatches: false,
        loadingUsers: false,
        loadingLiveMatches: false,
        activeSection: 'matches',
        activeMatchPopupShown: false,

        // Paris V/N/D sur les matchs en live : issue sélectionnée et message, par match
        betSelection: {},
        betMessages: {},
        // Camp dont la rangée d'écarts de buts est dépliée, par match (betKey).
        betMarginsOpen: {},
        betPending: false,

        init() {
            let self = this;
            window.addEventListener('game-panel-opened', function () {
                self.onPanelOpened();
            });

            window.addEventListener('active-live-match-detected', function (e) {
                if (!self.activeMatchPopupShown) {
                    let sidebar = document.querySelector('[x-data="sidebarData()"]');
                    if (sidebar && sidebar.__x && sidebar.__x.$data.activePanel === 'game') {
                        self.activeMatchPopupShown = true;
                        self.showActiveMatchPopup(e.detail);
                    }
                }
            });
        },

        onPanelOpened() {
            this.fetchMatchesToPlay();
            this.fetchLiveMatches();
            this.fetchMyLiveMatches();
            this.fetchUsersByStatus();
            this.checkActiveMatch();
        },

        checkActiveMatch() {
            let self = this;
            fetch('/notifications', { cache: 'no-store' })
                .then(r => r.json())
                .then(data => {
                    if (data.active_live_match && !self.activeMatchPopupShown) {
                        self.activeMatchPopupShown = true;
                        self.showActiveMatchPopup(data.active_live_match);
                    }
                })
                .catch(err => console.error('Active match check error:', err));
        },

        showActiveMatchPopup(match) {
            var existing = document.getElementById('game-active-match-popup');
            if (existing) existing.remove();

            var statusLabels = {
                'pending': 'En préparation',
                'formation_selection': 'Sélection de formation',
                'lineup_editing': 'Édition de composition',
                'ready_to_start': 'Prêt à démarrer',
                'waiting_team': 'En attente',
                'waiting_away': 'En attente adversaire',
                'waiting_home': 'En attente adversaire',
                'in_progress': '1ère mi-temps',
                'half_time': 'Mi-temps',
                'second_half': '2ème mi-temps',
                'paused': 'En pause',
                'extra_time_first': 'Prolongations 1ère',
                'extra_time_half': 'Prolongations mi-temps',
                'extra_time_second': 'Prolongations 2ème',
                'penalty_shootout': 'Tirs au but',
                'finished': 'Terminé',
                'waiting_notes': 'Notes en attente',
                'waiting_sheet': 'Feuille de match'
            };
            var statusLabel = statusLabels[match.status] || match.status;

            // Bouton d'action contextuel :
            //  - match amical : on peut l'annuler entièrement
            //  - match officiel non démarré (pas de coup d'envoi) : on peut l'ignorer (remise en attente)
            var actionBtn = '';
            if (match.is_friendly) {
                actionBtn = '<button id="game-popup-action" class="ranking-popup-btn ranking-popup-btn--cancel" data-action="cancel-friendly"><span class="material-icons">close</span> Annuler le match</button>';
            } else if (!match.has_started) {
                actionBtn = '<button id="game-popup-action" class="ranking-popup-btn ranking-popup-btn--cancel" data-action="ignore"><span class="material-icons">block</span> Ignorer</button>';
            }

            var popup = document.createElement('div');
            popup.id = 'game-active-match-popup';
            popup.className = 'ranking-popup-overlay';
            popup.innerHTML =
                '<div class="ranking-popup">' +
                    '<div class="ranking-popup-header"><h3>Match en cours</h3></div>' +
                    '<div class="ranking-popup-body">' +
                        '<p>Vous avez un match contre <strong>' + match.opponent_name + '</strong>.</p>' +
                        '<p class="text-sm text-gray-400 mt-1">Statut : ' + statusLabel + '</p>' +
                    '</div>' +
                    '<div class="ranking-popup-footer">' +
                        actionBtn +
                        '<a href="' + match.url + '" class="ranking-popup-btn ranking-popup-btn--go"><span class="material-icons">open_in_new</span> Rejoindre le match</a>' +
                        '<button id="game-popup-close" class="ranking-popup-btn ranking-popup-btn--close">Fermer</button>' +
                    '</div>' +
                '</div>';
            document.body.appendChild(popup);

            var self = this;
            document.getElementById('game-popup-close').addEventListener('click', function () { popup.remove(); });
            popup.addEventListener('click', function (e) { if (e.target === popup) popup.remove(); });

            var actionEl = document.getElementById('game-popup-action');
            if (actionEl) {
                actionEl.addEventListener('click', function () {
                    self.handleActiveMatchAction(match, this.getAttribute('data-action'), popup, this);
                });
            }
        },

        handleActiveMatchAction(match, action, popup, btn) {
            var url = action === 'cancel-friendly'
                ? '/matches/' + match.match_id + '/live/cancel-friendly'
                : '/matches/' + match.match_id + '/live/ignore';
            var confirmMsg = action === 'cancel-friendly'
                ? 'Annuler ce match amical ?'
                : 'Ignorer ce match ? Il sera remis en attente.';
            if (!window.confirm(confirmMsg)) return;

            btn.disabled = true;
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        popup.remove();
                    } else {
                        alert(data.message || 'Erreur lors de l\'opération');
                        btn.disabled = false;
                    }
                })
                .catch(err => {
                    console.error('Active match action error:', err);
                    alert('Erreur lors de l\'opération');
                    btn.disabled = false;
                });
        },

        switchSection(section) {
            this.activeSection = section;
        },

        fetchMatchesToPlay() {
            let self = this;
            this.loadingMatches = true;
            fetch('/notifications/users-with-matches', { cache: 'no-store' })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        self.usersWithMatches = data.users;
                        self.pendingProposals = data.pending_proposals || [];
                        self.myPendingProposals = data.my_pending_proposals || [];
                    }
                    self.loadingMatches = false;
                })
                .catch(err => { console.error(err); self.loadingMatches = false; });
        },

        formatMatchDate(dateStr) {
            if (!dateStr) return '';
            let d = typeof window.serverDate === 'function' ? window.serverDate(dateStr) : new Date(dateStr.replace('Z', '').replace(/\.\d+$/, ''));
            // Applique le décalage horaire de l'utilisateur (heures stockées en heure de Paris)
            const tzOffset = parseInt(document.querySelector('meta[name="timezone-offset"]')?.content || '0');
            if (tzOffset) d.setHours(d.getHours() + tzOffset);
            let days = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
            let day = days[d.getDay()];
            let date = d.getDate();
            let months = ['jan', 'fév', 'mar', 'avr', 'mai', 'jun', 'jul', 'aoû', 'sep', 'oct', 'nov', 'déc'];
            let month = months[d.getMonth()];
            let hours = String(d.getHours()).padStart(2, '0');
            let mins = String(d.getMinutes()).padStart(2, '0');
            return day + ' ' + date + ' ' + month + ' à ' + hours + ':' + mins;
        },

        // Décale une liste de créneaux "HH:MM" (stockés en heure de Paris) vers le fuseau de l'utilisateur
        shiftTimes(times) {
            if (!times || !times.length) return '';
            const tzOffset = parseInt(document.querySelector('meta[name="timezone-offset"]')?.content || '0');
            return times.map(t => {
                const [hStr, m] = t.split(':');
                const h = ((parseInt(hStr) + tzOffset) % 24 + 24) % 24;
                return String(h).padStart(2, '0') + ':' + m;
            }).join(', ');
        },

        fetchUsersByStatus() {
            let self = this;
            this.loadingUsers = true;
            fetch('/notifications/users-by-status', { cache: 'no-store' })
                .then(r => r.json())
                .then(data => {
                    if (data.success) self.usersByStatus = data.users;
                    self.loadingUsers = false;
                })
                .catch(err => { console.error(err); self.loadingUsers = false; });
        },

        fetchLiveMatches() {
            let self = this;
            this.loadingLiveMatches = true;
            let competitionId = window.location.pathname.match(/\/competitions\/(\d+)/)?.[1]
                || document.querySelector('meta[name="current-competition-id"]')?.content;
            if (!competitionId) { this.loadingLiveMatches = false; return; }

            fetch('/competitions/' + competitionId + '/live-matches', { cache: 'no-store' })
                .then(r => r.json())
                .then(data => {
                    if (data.success) self.liveMatches = data.matches;
                    self.loadingLiveMatches = false;
                })
                .catch(err => { console.error(err); self.loadingLiveMatches = false; });
        },

        // --- Paris V/N/D sur les matchs en live -------------------------------------
        // Les cotes arrivent déjà dans /competitions/{id}/live-matches (clé `bet`) :
        // sélectionner une issue puis une mise suffit, on rafraîchit ensuite la liste.

        /** Clé de sélection d'un pari : un match ranking et un match de compétition
         *  peuvent porter le même id, la famille (`kind`) les sépare. */
        betKey(match) {
            return (match.kind || 'match') + '-' + match.id;
        },

        get betStakes() {
            return window.matchBetting.stakes;
        },

        betLabel(outcome) {
            return window.matchBetting.outcomeLabel(outcome);
        },

        betSide(outcome) {
            return window.matchBetting.sideOf(outcome);
        },

        /** Entrée de cote d'une issue (V/N/D ou écart `home+2`) dans la quote du match. */
        betEntry(match, outcome) {
            return window.matchBetting.entryFor(match.bet, outcome);
        },

        /** Écarts de buts proposés à un camp. */
        betMargins(match, side) {
            return window.matchBetting.marginsFor(match.bet, side);
        },

        betMarginCaption(match, side) {
            const name = side === 'home' ? match.home_user : match.away_user;
            return window.matchBetting.t('bets.margin_caption', { name: name || (side === 'home' ? 'Domicile' : 'Extérieur') });
        },

        toggleBetMargins(match, side) {
            const key = this.betKey(match);
            this.betMarginsOpen[key] = this.betMarginsOpen[key] === side ? null : side;
            // Une sélection V/N/D ou un écart de l'autre camp n'a plus de sens ici.
            const selected = this.betSelection[key];
            if (selected && window.matchBetting.parseOutcome(selected).side !== this.betMarginsOpen[key]) {
                this.betSelection[key] = null;
            }
            delete this.betMessages[key];
        },

        betTitle(match, outcome) {
            const parsed = window.matchBetting.parseOutcome(outcome);
            const names = { home: match.home_user, draw: 'Match nul', away: match.away_user };
            const name = (names[parsed.side] || '?') + (parsed.margin ? ' +' + parsed.margin : '');
            const book = this.betEntry(match, outcome)?.bookmaker;
            if (!this.betBettable(match, outcome)) return name + ' — ' + window.matchBetting.t('bets.too_short');
            return name + (book ? ' — ' + book : '');
        },

        betBettable(match, outcome) {
            return window.matchBetting.isBettable(this.betEntry(match, outcome));
        },

        betStakeAllowed(match, stake) {
            const outcome = this.betSelection[this.betKey(match)];
            return window.matchBetting.stakeAllowed(stake, this.betEntry(match, outcome)?.odds, match.bet?.max_return);
        },

        formatGp(amount) {
            return window.matchBetting.formatGp(amount);
        },

        shortGp(amount) {
            return window.matchBetting.shortGp(amount);
        },

        selectBetOutcome(matchId, outcome) {
            this.betSelection[matchId] = this.betSelection[matchId] === outcome ? null : outcome;
            // Un V/N/D simple referme la rangée d'écarts.
            if (this.betSelection[matchId] && !window.matchBetting.parseOutcome(outcome).margin) {
                this.betMarginsOpen[matchId] = null;
            }
            delete this.betMessages[matchId];
        },

        placeBet(match, stake) {
            const outcome = this.betSelection[this.betKey(match)];
            if (!outcome || this.betPending) return;

            this.betPending = true;
            const oddsSeen = this.betEntry(match, outcome)?.odds;

            window.matchBetting.place(match.id, outcome, stake, oddsSeen)
                .then(data => {
                    this.betPending = false;
                    this.betMessages[this.betKey(match)] = { text: data.message, type: data.success ? 'success' : 'error' };
                    if (data.success) {
                        this.betSelection[this.betKey(match)] = null;
                        this.betMarginsOpen[this.betKey(match)] = null;
                        match.bet = data.quote;
                    } else if (data.odds_changed) {
                        match.bet.odds = data.odds;
                        if (data.margins) match.bet.margins = data.margins;
                    }
                })
                .catch(err => {
                    this.betPending = false;
                    this.betMessages[this.betKey(match)] = { text: 'Pari impossible pour le moment.', type: 'error' };
                    console.error(err);
                });
        },

        // Mes lives non terminés à reprendre (#329).
        fetchMyLiveMatches() {
            let self = this;
            fetch('/my-live-matches', { cache: 'no-store' })
                .then(r => r.json())
                .then(data => { if (data.success) self.myOngoingMatches = data.matches; })
                .catch(err => console.error(err));
        },

        inviteToMatch(userId, matchId) {
            let opponent = this.usersWithMatches.find(u => u.id === userId && u.match_id === matchId);
            if (!opponent) return;

            fetch('/notifications/invite-to-match', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ match_id: matchId, opponent_id: userId })
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        window.dispatchEvent(new CustomEvent('match-invitation-sent', {
                            detail: { opponent: opponent, matchId: matchId }
                        }));
                    } else {
                        alert(data.message || "Erreur lors de l'envoi de l'invitation");
                    }
                })
                .catch(err => {
                    console.error(err);
                    alert("Erreur lors de l'envoi de l'invitation");
                });
        },

        inviteFriendlyMatch(userId) {
            let allUsers = [
                ...(this.usersByStatus.ready_to_play || []),
                ...(this.usersByStatus.online || []),
                ...(this.usersByStatus.in_game || [])
            ];
            let opponent = allUsers.find(u => u.id === userId);
            if (!opponent) return;

            fetch('/notifications/invite-friendly-match', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ opponent_id: userId })
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        window.dispatchEvent(new CustomEvent('match-invitation-sent', {
                            detail: { opponent: opponent, matchId: data.match_id }
                        }));
                    } else {
                        alert(data.message || "Erreur lors de l'envoi de l'invitation");
                    }
                })
                .catch(err => {
                    console.error(err);
                    alert("Erreur lors de l'envoi de l'invitation");
                });
        },

        // Amical Gambardella (#324) : match amical joué avec l'effectif -21/académie.
        inviteGambardellaFriendly(userId) {
            let allUsers = [
                ...(this.usersByStatus.ready_to_play || []),
                ...(this.usersByStatus.online || []),
                ...(this.usersByStatus.in_game || [])
            ];
            let opponent = allUsers.find(u => u.id === userId);
            if (!opponent) return;

            fetch('/notifications/invite-friendly-match', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ opponent_id: userId, is_gambardella: true })
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        window.dispatchEvent(new CustomEvent('match-invitation-sent', {
                            detail: { opponent: opponent, matchId: data.match_id, isGambardella: true }
                        }));
                    } else {
                        alert(data.message || "Erreur lors de l'envoi de l'invitation");
                    }
                })
                .catch(err => {
                    console.error(err);
                    alert("Erreur lors de l'envoi de l'invitation");
                });
        },

        inviteRankingMatch(userId) {
            let allUsers = [
                ...(this.usersByStatus.ready_to_play || []),
                ...(this.usersByStatus.online || []),
                ...(this.usersByStatus.in_game || [])
            ];
            let opponent = allUsers.find(u => u.id === userId);
            if (!opponent) return;

            fetch('/notifications/invite-ranking-match', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ opponent_id: userId })
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        window.dispatchEvent(new CustomEvent('match-invitation-sent', {
                            detail: { opponent: opponent, matchId: data.match_id }
                        }));
                    } else {
                        alert(data.message || "Erreur lors de l'envoi de l'invitation");
                    }
                })
                .catch(err => {
                    console.error(err);
                    alert("Erreur lors de l'envoi de l'invitation");
                });
        },

        getCourtesyLabel(rating) {
            // Aligné sur User::getCourtesyGradeAttribute (échelle 1-12).
            const labels = { 1:'F', 2:'E-', 3:'E', 4:'D', 5:'D+', 6:'C', 7:'C+', 8:'B', 9:'B+', 10:'A', 11:'A+', 12:'S' };
            return labels[rating] || 'C';
        },

        /**
         * Étoiles d'ÉQUIPE (niveau), au barème du jeu : piste de 5 slots, jamais plus.
         * La valeur arrive déjà calculée du serveur (App\Support\StarRating appliqué
         * à la note d'effectif) — ne rien recalculer ici. La réputation, elle, se lit
         * en points : elle n'a plus d'étoiles.
         */
        teamStars(stars) {
            if (!stars) return '';
            let full = Math.floor(stars);
            let half = (stars % 1) >= 0.5 ? 1 : 0;
            let empty = 5 - full - half;
            let s = '';
            for (let i = 0; i < full; i++) s += '<i class="material-icons star-full">star</i>';
            if (half) s += '<i class="material-icons star-half">star_half</i>';
            for (let i = 0; i < empty; i++) s += '<i class="material-icons star-empty">star_border</i>';
            return s;
        },

        hasAvailability(user) {
            return user && user.availability && Object.keys(user.availability).length > 0;
        },

        createDemoMatch() {
            fetch('/matches/demo/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success && data.redirect) {
                        window.location.href = data.redirect;
                    } else {
                        alert(data.message || "Erreur lors de la création du match démo");
                    }
                })
                .catch(err => {
                    console.error(err);
                    alert("Erreur lors de la création du match démo");
                });
        },

        formatAvailability(availability) {
            if (!availability) return [];
            const dayLabels = { 'lundi':'Lun', 'mardi':'Mar', 'mercredi':'Mer', 'jeudi':'Jeu', 'vendredi':'Ven', 'samedi':'Sam', 'dimanche':'Dim' };
            const slotKeys = ['10-12', '12-14', '14-16', '16-18', '18-20', '20-22', '22-00'];
            const offset = parseInt(document.querySelector('meta[name="timezone-offset"]')?.content || '0');
            const formatted = [];
            Object.keys(dayLabels).forEach(day => {
                if (availability[day]) {
                    const slots = [];
                    slotKeys.forEach(slot => {
                        if (availability[day][slot]) {
                            const parts = slot.split('-');
                            let s = parseInt(parts[0]);
                            let e = parts[1] === '00' ? 24 : parseInt(parts[1]);
                            s = ((s + offset) % 24 + 24) % 24;
                            e = ((e + offset) % 24 + 24) % 24;
                            slots.push(s + 'h-' + e + 'h');
                        }
                    });
                    if (slots.length > 0) formatted.push({ day: dayLabels[day], slots: slots.join(', ') });
                }
            });
            return formatted;
        }
    };
};
